// extracted by mini-css-extract-plugin
export default {"alert_content":"alert_content___CKyKu","btn_warning":"btn_warning____MNWL","btn_warning_hollow":"btn_warning_hollow___Y_2BN"};